import { render, staticRenderFns } from "./BuyMediaModal.vue?vue&type=template&id=2df24c4a&scoped=true&"
import script from "./BuyMediaModal.vue?vue&type=script&lang=js&"
export * from "./BuyMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df24c4a",
  null
  
)

export default component.exports